import ArrowIcon from "../../Assets/Images/Arrow.svg";
import ClientElement2 from "../../Assets/Images/internation-client-1.png";
import ClientElement3 from "../../Assets/Images/internation-client-2.png";
import promisesImage from "../../Assets/Images/promises.png";
import bannerImage1 from "../../Assets/Images/about-us-banner.png";
import bannerImage2 from "../../Assets/Images/about-us-banner-2.png";
import bannerBarImage1 from "../../Assets/Images/about-us-banner-bar-3.png";
import bannerBarImage2 from "../../Assets/Images/about-us-banner-bar-4.png";
import aicLeftBannerImage from "../../Assets/Images/international-clients-image.png";
import { Col, Container, Row } from "reactstrap";
import { americanGlobalFidelity } from "../../constants/DummyValueConstants";
import FAQs from "../../Components/FAQs";
import HealthInsuranceHero from "../../Components/HealthInsuranceHero";
import GlobalFidelity from "../../Components/GlobalFidelity";
import OurPromise from "../../Components/OurPromise";
import "./About.css";
import NavBar from "../../Components/NavBar";
import AmBest from "../../Components/AmBest/AmBest";
import { useRef, useState } from "react";
import Great from "../../Components/Great/Great";
import Ward from "../../Components/Ward/Ward";
import InternationalClientsData from "./InternationalClientsData";
import { useAnimateOnScroll } from "../../Hooks/useAnimationScroll";
import { useTranslation } from "../../Hooks/useTranslation"; // Import the hook

import bannerMobileImage2 from "../../Assets/Images/about-us-banner-mobile-2.png";

const componentMap = {
  AM: <AmBest />,
  Ward: <Ward />,
  Great: <Great />,
};

const About = () => {
  const translations = useTranslation(); // Get translations dynamically
  useAnimateOnScroll();

  const [change, setChange] = useState("AM");
  // Reference to the scroll target section
  const scrollToRef = useRef(null);

  // Scroll handler
  const scrollToContent = () => {
    scrollToRef.current.scrollIntoView({ behavior: "smooth" });
  };
  return (
    <>
      <NavBar />
      <div className="about-wrap">
        <div className="about-top md:min-h-screen bg-[#0D4248] flex justify-center items-center text-white text-xl">
          <Container>
            <Row
              id="about-top-banner"
              className="flex flex-col lg:flex-row  md:space-x-12"
            >
              <Col lg={4} className="flex-1 lg:order-1 order-2 z-10">
                <div className="about-content-top">
                  <div className="max-w-[445px] animate__animated animate__fadeInUp md:px-0 pl-4 about-inner-content">
                    <h1 className="leading-tight text-[20px] md:text-4xl font-semibold extra-title-heading">
                      {translations.aboutUsBannerTitle}
                    </h1>
                    <p className="hidden max-w-[384px] lg:block text-[1rem] leading-normal md:text-[14px] mt-4 extra-para-vs">
                      {translations.aboutUsBannerDescription}
                    </p>
                    <p className="block lg:hidden leading-relaxed text-[14px] mt-4 extra-para-vs">
                      {translations.aboutUsBannerDescription}
                    </p>
                  </div>
                  <div className="md:absolute container z-[4] left-0 right-0 md:bottom-16 md:mt-0 mt-5 flex gap-3 items-center arrow-about-banner">
                    <div
                      className="arrow-border flex items-center justify-center border-2 border-white rounded-full w-[88px] h-[50px] cursor-pointer"
                      onClick={scrollToContent}
                    >
                      <img
                        src={ArrowIcon}
                        alt="AFGSL"
                        className="logo animate__animated animate__bounce animate__delay-2s animate__repeat-3"
                      />
                    </div>
                    <p className="text-sm mb-0 lg:block hidden ">
                      {" "}
                      {translations.aboutUsBannerButton}
                    </p>
                  </div>
                </div>
              </Col>
              <Col lg={8} className="relative flex-1 lg:order-2 order-1">
                <div className="right-images flex image-section">
                  <img
                    src={bannerImage2}
                    alt="about-us-banner-image"
                    className="image-section-banner-2 animate__animated animate__fadeInLeft hidden md:block"
                  />
                  <img
                    src={bannerMobileImage2}
                    alt="about-us-banner-image"
                    className="image-section-banner-2 animate__animated animate__fadeInLeft  md:hidden block"
                  />

                  <img
                    src={bannerImage1}
                    alt="about-us-banner-image"
                    className="image-section-banner-1 animate__animated animate__fadeInRight"
                  />
                  <img
                    src={bannerBarImage1}
                    alt="about-us-banner-image"
                    className="image-section-banner-3 absolute animate__animated animate__fadeInUp"
                  />
                  <img
                    src={bannerBarImage2}
                    alt="about-us-banner-image"
                    className="image-section-banner-4 absolute animate__animated animate__fadeInDown"
                  />
                </div>
              </Col>
            </Row>
            <div
              id="american-fidelity"
              className="flex flex-col justify-space-between md:flex-row lg:space-x-3 mt-12 lg:pt-40 mb-8 pt-12 pb-12  lg:pl-0 px-4"
            >
              <div
                sm={12}
                lg={6}
                md={6}
                className="mt-5 pt-5 flex-1 xl:flex-2 md:pe-3 z-10 american-fidelity-left-col animate__animated animate__fadeInLeft"
              >
                {/* <p className="text-sm mb-2 lg:hidden block">Back up</p> */}
                <h3 className="lg:text-[36px] lg:leading-[44px] text-[24px] leading-[28px] tracking-tight font-semibold mb-4">
                  {translations.americanfidelityTitle}
                </h3>
                <p className="text-[14px] leading-[20px] text-justify lg:text-left lg:text-[16px] lg:leading-[22px] mb-4 extra-para-vs max-w-[592px] tracking-tight">
                  {translations.americanfidelityDescription}
                </p>
                <p className="lg:text-[16px] text-justify lg:text-left lg:leading-[22px] text-[14px] leading-[20px] mb-6 extra-para-vs max-w-[592px] tracking-tight">
                  {translations.americanfidelityDescription2}
                </p>
                <p className="lg:text-[16px] lg:leading-[22px] text-[14px] leading-[20px] extra-title24 tracking-tight mb-0">
                  {translations.americanfidelityAmount}
                </p>
              </div>
              <div sm={12} lg={6} md={6} className="mt-5 pt-5 flex-1">
                <ul className="list-none american-fidelity-right-col max-w-[450px] md:ms-auto">
                  <li className="border-b-[1px] border-[#53BCC8] lg:pb-6 pb-6 flex items-center animate__animated animate__fadeInRight animate__delay-0s  lg:px-0 px-2">
                    <div className="text-[1.5rem] md:text-[2.5rem] md:leading-[2.5rem] font-semibold tracking-tight flex-none w-[120px] md:w-[160px] aff-numbers">
                      $ 1.3 B<sup className="lg:inline-block">*</sup>{" "}
                    </div>
                    <div className="text-[16px] leading-[22px] pl-0 md:pl-3 pl-md-5 lg:pb-0 aff-numbers-content">
                      <span
                        className="lg:block hidden"
                        dangerouslySetInnerHTML={{
                          __html: translations.afaConsolidatedTextOne,
                        }}
                      ></span>
                      <span
                        className="lg:hidden block"
                        dangerouslySetInnerHTML={{
                          __html: translations.afaConsolidatedTextOne,
                        }}
                      ></span>
                    </div>
                  </li>
                  <li className="border-b-[1px]  lg:border-[#53BCC8] border-[#FFE9B1] lg:pb-6 pb-6 lg:pt-6 pt-6 flex items-center animate__animated animate__fadeInRight animate__delay-1s lg:px-0 px-2">
                    <div className="text-[1.5rem] md:text-[2.5rem] md:leading-[2.5rem] font-semibold tracking-tight  flex-none w-[120px] md:w-[160px] aff-numbers">
                      $ 16.2 B<sup className="lg:inline-block">*</sup>
                    </div>
                    <div className="text-[16px] leading-[22px] pl-0 md:pl-3 pl-md-5 lg:pb-0 aff-numbers-content">
                      <span
                        className="lg:block hidden"
                        dangerouslySetInnerHTML={{
                          __html: translations.afaConsolidatedTextTwo,
                        }}
                      ></span>
                      <span
                        className="lg:hidden block"
                        dangerouslySetInnerHTML={{
                          __html: translations.afaConsolidatedTextTwo,
                        }}
                      ></span>
                    </div>
                  </li>
                  <li
                    className="flex lg:pb-6 pb-6 lg:pt-6 pt-6 flex items-center animate__animated animate__fadeInRight animate__delay-2s lg:px-0 px-2"
                    ref={scrollToRef}
                  >
                    <div className="text-[1.5rem] md:text-[2.5rem] md:leading-[2.5rem] font-semibold tracking-tight  flex-none w-[120px] md:w-[160px] aff-numbers">
                      $ 240 M<sup className="">*</sup>
                    </div>
                    <div className="text-[16px] leading-[22px] pl-0 md:pl-3 pl-md-5 aff-numbers-content">
                      <span
                        className="lg:block hidden"
                        dangerouslySetInnerHTML={{
                          __html: translations.afaConsolidatedTextThree,
                        }}
                      ></span>
                      <span
                        className="lg:hidden block"
                        dangerouslySetInnerHTML={{
                          __html: translations.afaConsolidatedTextThree,
                        }}
                      ></span>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </Container>
        </div>

        <div
          id="values-guide-us"
          className="supeior-rating py-20 pb-12 lg:py-36"
        >
          <Container>
            <div className="flex justify-between lg:space-x-4 lg:flex-row flex-col ">
              <div className="flex-1 animate__animated  mt-0 lg:mt-28 animate__fadeInLeft lg:pl-0 pl-4">
                <p className="text-sm text-gray-600 mb-1 learnmoreacc">
                  {translations.historyLearnMore}
                </p>
                <h3 className="lg:text-[40px] font-semibold mb-4 lg:leading-[44px] text-[24px] leading-[28px] tracking-tight extra-title-heading">
                  {translations.valuesHeading}
                </h3>
                <div className="block lg:hidden mb-6">
                  <hr className="bordertitle-line"></hr>
                </div>
                <p className="text-sm lg:block hidden mb-8 extra-para-vs">
                  {translations.valuesDescription}
                </p>
                <div className="active-section flex lg:justify-center justify-space-between gap-2 bg-white rounded-full lg:mr-0 mr-4 lg:mt-4 mt-8 mb-4 max-w-[420px]">
                  <button
                    onClick={() => setChange("AM")}
                    className={`flex-1 content text-[12px] lg:text-[14px] extra-btn-font ${
                      change === "AM" ? "active bg-[#0D4248]" : ""
                    } font-medium  ${
                      change === "AM" ? "text-white" : "text-black"
                    } py-3 px-4 rounded-full`}
                  >
                    {translations.valuesAMBestTab}
                  </button>
                  <button
                    onClick={() => setChange("Ward")}
                    className={`flex-1 content text-[12px] lg:text-[14px] extra-btn-font ${
                      change === "Ward" ? "active bg-[#0D4248]" : ""
                    } font-medium  ${
                      change === "Ward" ? "text-white" : "text-black"
                    } py-3 px-4 rounded-full`}
                  >
                    <span className="hidden md:block">
                      {translations.valuesWardsTab}
                    </span>
                    <span className="block md:hidden">
                      {translations.valuesWardsTab} 50
                    </span>
                  </button>
                  <button
                    onClick={() => setChange("Great")}
                    className={`flex-2 content text-[12px] lg:text-[14px] extra-btn-font ${
                      change === "Great" ? "active bg-[#0D4248]" : ""
                    } font-medium  ${
                      change === "Great" ? "text-white" : "text-black"
                    } py-3 px-4 rounded-full`}
                  >
                    <span className="hidden md:block">
                      {translations.valuesOtherRewardsTab}
                    </span>
                    <span className="block md:hidden">Great Place to Work</span>
                  </button>
                </div>
              </div>
              {componentMap[change] || null}
            </div>
          </Container>
        </div>

        {/* <ValuesGuideUs /> */}
        <div
          id="about-international-client-id"
          className="about-international-client bg-[#F7F6F2] md:min-h-screen py-16 md:py-20 flex justify-center  flex-wrap flex-col-reverse lg:flex-col md:flex-nowrap"
        >
          <div className="container">
            <div className="flex flex-col lg:flex-row gap-1 items-center">
              <div className="lg:w-1/2">
                <div>
                  <div className="aic-content">
                    <InternationalClientsData />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="tab-capsule-img-box relative lg:absolute w-[100%] lg:w-[50%] pl-[20px] right-0 min-h-[calc(100%-160px)]">
            <div className="block md:hidden ">
              <h2 className="text-[26px] md:text-[40px] font-bold mb-2 FAQheading ">
                {translations.internationalHeading}
              </h2>
              <hr class="bordertitle-line mb-4"></hr>
            </div>
            <div className="circle-div lg:ml-0 mb-[0] md:mb-0 animate__animated animate__fadeInRight h-[100%]">
              <img
                src={aicLeftBannerImage}
                alt="International Client Element"
                className="object-cover"
                width="100%"
                height="100%"
              />
            </div>
          </div>
        </div>

        <div className="health ">
          <HealthInsuranceHero pageName="about" />
        </div>
      </div>
    </>
  );
};

export default About;
